// extracted by mini-css-extract-plugin
module.exports = {"Quill":"QuillEditor_Quill__1mMoO","Label":"QuillEditor_Label__oZbzo"};